module.exports = __webpack_public_path__ + "static/media/23-2.14248813.png";